import { LockOpenRemoveIcon } from './LockOpenRemoveIcon';

/**
 * author: Colton Wiscombe
 * id DBA50293-BCD6-4CC6-81E7-E63AF1EB56AE
 * name lock-open-remove
 * version: 5.8.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lock-open-remove.svg
 * tags
 * - Lock 
 */
export const UnlockedRemoveIcon = LockOpenRemoveIcon;
export default UnlockedRemoveIcon